import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'
import { MessageSquare } from 'lucide-react'

import PageLayout from '../../components/layout/page-layout'
import { Container } from '../../components/ui/container'
import { pagePanel } from '../../components/layout/page-styles'
import { ChatConversationList, ChatPanel } from './chat-panel'
import type { ChatConversation } from '../../services/chat.service'

export default function ChatPage() {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const employeeFromUrl = searchParams.get('employee')

  const [selected, setSelected] = useState<ChatConversation | null>(null)

  useEffect(() => {
    if (employeeFromUrl) {
      setSelected({
        id: '',
        employeeUserId: employeeFromUrl,
        employeeName: '',
        companyId: '',
        createdAt: new Date(0).toISOString(),
      })
    }
  }, [employeeFromUrl])

  return (
    <PageLayout>
      <Container>
        <div className='mb-6'>
          <h1 className='text-xl font-semibold text-neutral-900 flex items-center gap-2'>
            <MessageSquare className='w-5 h-5 text-primary-600' />
            {t('chat.title')}
          </h1>
          <p className='text-sm text-neutral-500 mt-0.5'>{t('chat.subtitle')}</p>
        </div>

        <div className='grid grid-cols-1 lg:grid-cols-12 gap-6'>
          <aside className='lg:col-span-4'>
            <div className={pagePanel}>
              <div className='px-4 py-3 border-b border-neutral-100'>
                <h2 className='text-sm font-semibold text-neutral-900'>{t('chat.employees')}</h2>
              </div>
              <ChatConversationList
                selectedEmployeeId={selected?.employeeUserId}
                onSelect={setSelected}
              />
            </div>
          </aside>

          <section className='lg:col-span-8'>
            {selected ? (
              <ChatPanel
                employeeUserId={selected.employeeUserId}
                employeeName={selected.employeeName}
                conversationId={selected.id || undefined}
                onConversationCreated={conv =>
                  setSelected(prev =>
                    prev ? { ...prev, id: conv.id, employeeName: conv.employeeName } : conv
                  )
                }
                className='min-h-[520px]'
              />
            ) : (
              <div className={`${pagePanel} flex items-center justify-center min-h-[520px] p-8`}>
                <p className='text-sm text-neutral-500 text-center'>{t('chat.selectEmployee')}</p>
              </div>
            )}
          </section>
        </div>
      </Container>
    </PageLayout>
  )
}
